/** Phone landscape often reports as `tablet` because the viewport is wide. */
const HANDHELD_LANDSCAPE_MAX_HEIGHT_PX = 520;

export function isHandheldLandscape(
  deviceType: string,
  isLandscape: boolean,
  maxHeightPx = HANDHELD_LANDSCAPE_MAX_HEIGHT_PX
): boolean {
  if (!isLandscape || deviceType === 'desktop') {
    return false;
  }
  if (deviceType === 'mobile') {
    return true;
  }
  return (
    deviceType === 'tablet' &&
    typeof window !== 'undefined' &&
    window.innerHeight <= maxHeightPx
  );
}
